// extracted by mini-css-extract-plugin
module.exports = {"siteExclusions":"SiteExclusions_siteExclusions__1QAi2","table":"SiteExclusions_table__1OwUB"};